import React, { useState, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import api from "../../Api.js";
import "./Booking.css";
import SuccessModal from "../ExtraComponent/SuccessModal.jsx";
import Ourpackages from "../Home/Packages.jsx";
import Common_navber from "../Home/Common_navber.jsx"
import { getProperties, OrderProperty, VerifyPayment } from "../../Services/Operations/ProductAPI.js";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const IconUsers = () => (
  <svg width="16" height="16" fill="none">
    <circle cx="8" cy="5" r="3" stroke="black" />
    <path d="M2 14c1.5-3 10.5-3 12 0" stroke="black" />
  </svg>
);

const IconPlate = () => (
  <svg width="16" height="16" fill="none">
    <circle cx="8" cy="8" r="6" stroke="black" />
  </svg>
);

const IconHall = () => (
  <svg width="16" height="16" fill="none">
    <rect x="2" y="4" width="12" height="8" stroke="black" />
  </svg>
);

const IconMoney = () => (
  <svg width="16" height="16" fill="none">
    <circle cx="8" cy="8" r="6" stroke="black" />
    <path d="M6 8h4" stroke="black" />
  </svg>
);



const styles = {
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "20px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
    maxWidth: "420px",
    margin: "20px auto",
    fontFamily: "sans-serif",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },

  title: {
    margin: 0,
    fontSize: "20px",
    color: "#000",
  },

  city: {
    margin: 0,
    fontSize: "13px",
    color: "#777",
  },

  status: {
    background: "#ffe8cc",
    color: "#ff8800",
    padding: "6px 10px",
    borderRadius: "8px",
    fontSize: "12px",
    textTransform: "capitalize",
  },

  body: {
    borderTop: "1px solid #eee",
    borderBottom: "1px solid #eee",
    padding: "12px 0",
  },

  address: {
    fontSize: "13px",
    color: "#555",
    marginBottom: "10px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
  },

  item: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    color: "#000",
  },

  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "12px",
  },

  small: {
    fontSize: "11px",
    color: "#888",
    margin: 0,
  },

  button: {
    background: "#ff8800",
    color: "#fff",
    border: "none",
    padding: "10px 14px",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};



function Test() {
      const { isAuthenticated ,token} = useSelector((state) => state.auth);
      const navigate=useNavigate()
    const today = dayjs();
    const minDate = today.add(1, "day");
    const [showModal, setShowModal] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [eventsData, setEventsData] = useState([]);
    const [FacilitiesData, setFacilitiesData] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState("All");
    const [selectedDate, setSelectedDate] = useState(null);
    const [price, setPrice] = useState(0);

    const[propertyList,setPropertyList]=useState([])

    // ✅ MAIN FORM DATA (REAL BACKEND STRUCTURE)
    const [formData, setFormData] = useState({
        additional_features: [],
        number_of_guest: "",
        plot: "",
        name: "",
        email: "",
        phone: "",
        event_name: "All",
        event_date: "",
        additional_message: "",
    });

    const [errors, setErrors] = useState({});
    // ================= FETCH DATA =================
    useEffect(() => {
        const fetchData = async () => {
            try {
                const cal = await api.get("banquet-calender");
                const fac = await api.get("banquet-customized_order-manage");
                const properties=await getProperties()
                console.log('properties',properties);
                setPropertyList(properties.data.data)
                

                setEventsData(cal.data.data);
                setFacilitiesData(fac.data.data);
            } catch (err) {
                console.log(err);
            }
        };
        fetchData();
    }, []);

    // ================= HANDLE INPUT =================
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFeatureChange = (feature) => {
        setFormData((prev) => {
            const additional_features = prev.additional_features.includes(feature)
                ? prev.additional_features.filter((f) => f !== feature)
                : [...prev.additional_features, feature];

            return { ...prev, additional_features };
        });
    };

    // ================= PRICE CALCULATION =================
    useEffect(() => {
        let total = 0;

        const guestItem = FacilitiesData.find(
            (i) =>
                i.facility_type === "Capacity" &&
                i.facility_name === formData.number_of_guest
        );

        if (guestItem) total += Number(guestItem.price);

        const areaItem = FacilitiesData.find(
            (i) =>
                i.facility_type === "Area" &&
                i.facility_name === formData.plot
        );

        if (areaItem) total += Number(areaItem.price);

        formData.additional_features.forEach((feat) => {
            const extra = FacilitiesData.find(
                (i) =>
                    i.facility_type === "Additional" &&
                    i.facility_name === feat
            );
            if (extra) total += Number(extra.price);
        });

        setPrice(total);
    }, [formData, FacilitiesData]);

    // ================= DATE SELECT =================
    const handleDateChange = (e) => {
        const selected = dayjs(e.target.value);
        if (selected.isBefore(minDate, "day")) {
            alert("Please select future date");
            return;
        }

        setSelectedDate(selected);
        setFormData({
            ...formData,
            event_date: selected.format("YYYY-MM-DD"),
        });
    };

    // ================= SUBMIT =================
    const handleSubmit = async () => {
        if (!formData.event_date) {
            alert("Select event date");
            return;
        }

        const payload = {
            ...formData,
            additional_features: formData.additional_features.join(","),
        };

        const response = await api.post(
            "banquet/customized-event-inquiry",
            payload
        );

        if (response.data.status === "success") {
            //   alert("🎉 Submitted Successfully");
            setShowModal(true);
            setFormData({
                additional_features: [],
                number_of_guest: "",
                plot: "",
                name: "",
                email: "",
                phone: "",
                event_name: "All",
                event_date: "",
                additional_message: "",
            });
            setCurrentStep(1);
        }
    };

    const handleOrder=async(id)=>{
        try { let data={property_id:id}
            const res=await OrderProperty(data,token)
            console.log(res);
            if(res.status===200){
                toast.success("Order Booked")
                handlePayment(res.data)
            }
          //  
            
        } catch (error) {
            console.log(error);
            
        }
    }

          const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const verifyPayment=async(data)=>{
try {
  if(!token){
     toast.warning("Unauthorized login first")
        navigate("/login")
  }
  console.log(data);
  const res= await VerifyPayment(data,token)
  console.log(res);
  if(res.status===200){
    toast.success(
"Payment successful & property booked")
  }
  
  
} catch (error) {
  console.log(error);
  
}
}


  const handlePayment = async (data) => {
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load");
      return;
    }

    // Call your backend to create order
    // const data = await fetch("/api/create-order", {
    //   method: "POST",
    // }).then((t) => t.json());

    const options = {
      key: data.key, // from Razorpay dashboard
      amount: data.amount,
      currency: "INR",
      name: "Siance Software",
      description: "Test Transaction",
      order_id: data.order_id,

      handler: function (response) {
        console.log("Payment Success:", response);
         verifyPayment(response)
        // send this response to backend for verification
        // response.razorpay_payment_id
        // response.razorpay_order_id
        // response.razorpay_signature
      },
 
      prefill: {
        name: "John Doe",
        email: "john@example.com",
        contact: "9999999999",
      },

      theme: {
        color: "#3399cc",
      },
    };

   

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

    // ================= FILTER DATA =================
    const GuestCount = FacilitiesData.filter(
        (f) => f.facility_type === "Capacity"
    );

    const Area = FacilitiesData.filter(
        (f) => f.facility_type === "Area"
    );

    const Additional = FacilitiesData.filter(
        (f) => f.facility_type === "Additional"
    );

    const nextStep = () => {
        if (validateStep()) {
            if (currentStep < 3) {
                setCurrentStep(currentStep + 1);
            }
        }
    };

    const goToStep = (step) => setCurrentStep(step);

    const steps = [
        "Personal information",
        "Guest information",
        "Booking Overview",
    ];
    const [activeButton, setActiveButton] = useState(false);

    const validateStep = () => {
        let newErrors = {};

        if (currentStep === 1) {
            if (!formData.name.trim()) {
                newErrors.name = "Full name is required";
            }

            if (!formData.email.trim()) {
                newErrors.email = "Email is required";
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
                newErrors.email = "Enter valid email";
            }

            if (!formData.phone.trim()) {
                newErrors.phone = "Phone number is required";
            } else if (!/^[0-9]{10}$/.test(formData.phone)) {
                newErrors.phone = "Enter valid 10 digit phone number";
            }

            if (!formData.event_date) {
                newErrors.event_date = "Event date is required";
            }
        }

        if (currentStep === 2) {
            if (!formData.number_of_guest) {
                newErrors.number_of_guest = "Please select number of guests";
            }

            if (!formData.plot) {
                newErrors.plot = "Please select venue area";
            }
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const PropertyCard = ({ data }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.4 }}
      style={styles.card}
    >
      {/* Header */}
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>{data.property_name}</h2>
          <p style={styles.city}>{data.city}</p>
        </div>

        <span style={styles.status}>
          {data.availability_status}
        </span>
      </div>

      {/* Body */}
      <div style={styles.body}>
        <p style={styles.address}>
          📍 {data.address}
        </p>

        <div style={styles.grid}>
          <div style={styles.item}>
            <IconUsers />
            <span>{data.capacity_min} - {data.capacity_max}</span>
          </div>

          <div style={styles.item}>
            <IconPlate />
            <span>₹{data.price_per_plate}/plate</span>
          </div>

          <div style={styles.item}>
            <IconHall />
            <span>{data.hall_type}</span>
          </div>

          <div style={styles.item}>
            <IconMoney />
            <span>₹{data.all_total_price}</span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <div>
          <p style={styles.small}>Decoration</p>
          <strong>₹{data.decoration_charges}</strong>
        </div>

        <div>
          <p style={styles.small}>Room</p>
          <strong>₹{data.room_charges}</strong>
        </div>

        <motion.button
          whileTap={{ scale: 0.95 }}
          style={styles.button}
          onClick={()=>handleOrder(data.id)}
        >
          Order
        </motion.button>
      </div>
    </motion.div>
  );
};



    return (
        <div className="service-wrapper">
            <Common_navber/>
              <div className="section-header">
                <span className="line"></span>
                <p>Our properties</p>
                <span className="line"></span>
            </div>

           <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",justifyContent:"center"}}> {
                propertyList.map(i=>(
                    <PropertyCard data={i}/>
                ))
            }</div>
            <div className="section-header">
                <span className="line"></span>
                <p>Our Services</p>
                <span className="line"></span>
            </div>

            <div className="booking-action-wrapper">
                <button className={`booking-btn ${activeButton ? "activebutton" : ""}`} onClick={() => setActiveButton(!activeButton)}>
                    Our Packages
                </button>

                <button className={`booking-btn ${!activeButton ? "activebutton" : ""}`} onClick={() => setActiveButton(!activeButton)}>
                    Customize Booking
                </button>
            </div>

            {activeButton ? <Ourpackages /> :
                <div className="service-card">
                    <SuccessModal show={showModal} onClose={() => setShowModal(false)} message="🎉 Our team will reach out to you shortly through email or phone." />

                    {/* LEFT TRACKER */}
                    <div className="steps-section">
                        {steps.map((step, index) => {
                            const stepNumber = index + 1;
                            return (
                                <div
                                    key={index}
                                    className="step-item"
                                    onClick={() => goToStep(stepNumber)}
                                >
                                    <div
                                        className={`step-number ${currentStep === stepNumber
                                            ? "active"
                                            : currentStep > stepNumber
                                                ? "completed"
                                                : ""
                                            }`}
                                    >
                                        {stepNumber}
                                    </div>
                                    <h4>{step}</h4>
                                </div>
                            );
                        })}
                    </div>

                    {/* RIGHT SECTION */}
                    <div className="form-section">

                        {/* ================= STEP 1 ================= */}
                        {currentStep === 1 && (
                            <>
                                <h3 className="guest-step-title">Personal Information</h3>

                                <div className="form-grid">
                                    <div className="form-field">
                                        <label>Full Name*</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Enter your full name"
                                        />
                                        {errors.name && <p className="error-text">{errors.name}</p>}
                                    </div>

                                    <div className="form-field">
                                        <label>Email*</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="Enter your email"
                                        />
                                        {errors.email && <p className="error-text">{errors.email}</p>}
                                    </div>

                                    <div className="form-field">
                                        <label>Phone*</label>
                                        <input
                                            type="text"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="Enter phone number"
                                        />
                                        {errors.phone && <p className="error-text">{errors.phone}</p>}
                                    </div>

                                    <div className="form-field">
                                        <label>Event Date*</label>
                                        <input
                                            type="date"
                                            value={formData.event_date}
                                            onChange={handleDateChange}
                                        />
                                        {errors.event_date && <p className="error-text">{errors.event_date}</p>}
                                    </div>
                                </div>

                                <button onClick={nextStep} className="continue-btn">
                                    Continue
                                </button>
                            </>
                        )}

                        {/* ================= STEP 2 ================= */}
                        {currentStep === 2 && (
                            <div className="guest-step-wrapper">
                                <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                                    <h3 className="guest-step-title">Guest Information</h3><h4 className="guest-step-title">Total Amount: ₹{price}</h4>
                                </div>

                                <div className="guest-form-grid">

                                    <div className="guest-form-field">
                                        <label>Number of Guests*</label>
                                        <select
                                            name="number_of_guest"
                                            value={formData.number_of_guest}
                                            onChange={handleChange}
                                            className="guest-select"
                                        >
                                            <option value="">Select Guests</option>
                                            {GuestCount.map((g, i) => (
                                                <option key={i} value={g.facility_name}>
                                                    {g.facility_name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.number_of_guest && <p className="error-text">{errors.number_of_guest}</p>}
                                    </div>

                                    <div className="guest-form-field">
                                        <label>Venue Area*</label>
                                        <select
                                            name="plot"
                                            value={formData.plot}
                                            onChange={handleChange}
                                            className="guest-select"
                                        >
                                            <option value="">Select Area</option>
                                            {Area.map((a, i) => (
                                                <option key={i} value={a.facility_name}>
                                                    {a.facility_name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.plot && <p className="error-text">{errors.plot}</p>}
                                    </div>

                                    <div className="guest-form-field guest-full-width">
                                        <label>Additional Features</label>

                                        <div className="guest-checkbox-group">
                                            {Additional.map((item, i) => (
                                                <label key={i} className="guest-checkbox-item">
                                                    <input
                                                        type="checkbox"
                                                        checked={formData.additional_features.includes(
                                                            item.facility_name
                                                        )}
                                                        onChange={() =>
                                                            handleFeatureChange(item.facility_name)
                                                        }
                                                    />
                                                    <span>{item.facility_name}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="guest-form-field guest-full-width">
                                        <label>Additional Message</label>
                                        <textarea
                                            name="additional_message"
                                            value={formData.additional_message}
                                            onChange={handleChange}
                                            placeholder="Write your message"
                                            className="guest-textarea"
                                        />
                                    </div>
                                </div>

                                <button onClick={nextStep} className="continue-btn">
                                    Continue
                                </button>
                            </div>
                        )}

                        {/* ================= STEP 3 ================= */}
                        {currentStep === 3 && (
                            <div className="booking-overview-wrapper">

                                <h3 className="booking-overview-title">Booking Overview</h3>

                                <div className="booking-overview-card">

                                    <div className="overview-info-block">
                                        <h4 className="overview-block-title">Personal Information</h4>

                                        <div className="overview-row">
                                            <span>Name:</span>
                                            <span>{formData.name}</span>
                                        </div>

                                        <div className="overview-row">
                                            <span>Email:</span>
                                            <span>{formData.email}</span>
                                        </div>

                                        <div className="overview-row">
                                            <span>Phone:</span>
                                            <span>{formData.phone}</span>
                                        </div>

                                        <div className="overview-row">
                                            <span>Date:</span>
                                            <span>{formData.event_date}</span>
                                        </div>
                                    </div>


                                    <div className="overview-info-block">
                                        <h4 className="overview-block-title">Guest Information</h4>

                                        <div className="overview-row">
                                            <span>Guests:</span>
                                            <span>{formData.number_of_guest}</span>
                                        </div>

                                        <div className="overview-row">
                                            <span>Area:</span>
                                            <span>{formData.plot}</span>
                                        </div>

                                        <div className="overview-row">
                                            <span>Extras:</span>
                                            <span className="overview-ellipsis-text">{formData.additional_features.join(", ") || "N/A"}</span>
                                        </div>

                                        <div className="overview-row">
                                            <span>Message:</span>
                                            <span className="overview-ellipsis-text">
                                                {formData.additional_message || "N/A"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="overview-price-box">
                                        <h2>Total Price</h2>
                                        <div className="overview-price-amount">₹ {price}</div>
                                    </div>

                                </div>

                                <button
                                    onClick={handleSubmit}
                                    className="continue-btn"
                                >
                                    Send Request
                                </button>

                            </div>
                        )}

                    </div>
                </div>
            }
        </div>
    );
}

export default Test;